/* unplugin-vue-components disabled */import script from "./CharacterLimitedField.vue?vue&type=script&setup=true&lang=js"
export * from "./CharacterLimitedField.vue?vue&type=script&setup=true&lang=js"

import "./CharacterLimitedField.vue?vue&type=style&index=0&id=ac8edeac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac8edeac"]])

export default __exports__